export const COMPANY = "A";
export const ADMINISTRATION = "B";
